/** KPI stat card for the usage metrics dashboard. */

import { Card, CardContent } from "@/shared/ui/card";
import { cn } from "@/shared/lib/utils";
import type { LucideIcon } from "lucide-react";

export interface MetricCardProps {
  label: string;
  value: string | number;
  hint?: string;
  icon?: LucideIcon;
  className?: string;
}

export default function MetricCard({
  label,
  value,
  hint,
  icon: Icon,
  className,
}: MetricCardProps) {
  return (
    <Card className={cn("card-hover", className)}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-2">
          <span className="font-mono text-[9px] font-medium uppercase tracking-[0.1em] text-muted-foreground">
            {label}
          </span>
          {Icon && <Icon className="size-4 shrink-0 text-primary" aria-hidden="true" />}
        </div>
        <p className="mt-2 font-mono text-2xl font-semibold tabular-nums text-foreground">
          {value}
        </p>
        {hint && (
          <p className="mt-1 text-[11px] text-muted-foreground">{hint}</p>
        )}
      </CardContent>
    </Card>
  );
}
